import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import './PageFAbody.css'; // Import the CSS file
import { format } from 'date-fns';

export default function PageFAbody({ view }) {
    const [orders, setOrders] = useState([]);
    const [users, setUsers] = useState([]);
    const [distinctDates, setDistinctDates] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [dateSearchTerm, setDateSearchTerm] = useState(""); // For searching by date
    const [currentPage, setCurrentPage] = useState(1);
    const ordersPerPage = 25;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (view === 'orders') {
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/allOrders`);
                    setOrders(response.data);
                    setFilteredOrders(response.data);
                } else if (view === 'users') {
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/users`);
                    setUsers(response.data);
                    setFilteredUsers(response.data);
                } else if (view === 'pending') {
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/pendingOrders`);
                    setDistinctDates(response.data);
                } else if (view === 'complete') {
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/completeOrders`);
                    setDistinctDates(response.data);
                }
               

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [view]);

    // Pagination logic
    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);
    const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);

    const indexOfLastUser = currentPage * ordersPerPage;
    const indexOfFirstUser = indexOfLastUser - ordersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
    const totalUserPages = Math.ceil(filteredUsers.length / ordersPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleRowClick = (phone) => {
        navigate('/usersPage', { state: { phone } });
    };

    const completeClick = (date) => {
        navigate('/completePage', { state: { date } });
    };

    const pendingClick = (date) => {
        navigate('/pendingPage', { state: { date } });
    };

    // Search functionality for orders
    const handleSearchOrders = () => {
        const filtered = orders.filter(order =>
            order.CustomerPhone.includes(searchTerm)
        );
        setFilteredOrders(filtered);
        setCurrentPage(1); // Reset to the first page after search
    };

    // Search functionality for users
    const handleSearchUsers = () => {
        const filtered = users.filter(user =>
            user.Phone.includes(searchTerm)
        );
        setFilteredUsers(filtered);
        setCurrentPage(1); // Reset to the first page after search
    };

    // Search functionality for pending and complete dates
    const handleSearchDates = () => {
        const filteredDates = distinctDates.filter(date => 
            format(new Date(date.OrderDate), 'yyyy-MM-dd').includes(dateSearchTerm)
        );
        setDistinctDates(filteredDates);
        setCurrentPage(1); // Reset to the first page after search
    };

    const handleRefresh = async () => {
        try {
            if (view === 'orders') {
                const response = await axios.get("http://localhost:3000/allOrders");
                setOrders(response.data);
                setFilteredOrders(response.data);
            } else if (view === 'users') {
                const response = await axios.get("http://localhost:3000/users");
                setUsers(response.data);
                setFilteredUsers(response.data);
            } else if (view === 'pending') {
                const response = await axios.get("http://localhost:3000/pendingOrders");
                setDistinctDates(response.data);
            } else if (view === 'complete') {
                const response = await axios.get("http://localhost:3000/completeOrders");
                setDistinctDates(response.data);
            }
    
        } catch (error) {
            console.error('Error refreshing data:', error);
        }
        setSearchTerm('');
        setDateSearchTerm('');
        setCurrentPage(1); // Reset to the first page after refresh
    };

    return (
        <div className="table-container">




            {view === 'orders' && (
                <>
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Search by Phone"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ padding: "10px", flex: "1", marginRight: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                        />
                        <button onClick={handleSearchOrders} className="search-button"
                            style={{ padding: "10px 20px", marginRight: "10px", borderRadius: "5px", backgroundColor: "#009879", color: "white", border: "none", cursor: "pointer" }}>
                            Search
                        </button>
                        <button onClick={handleRefresh} className="refresh-button"
                            style={{ padding: "10px 20px", borderRadius: "5px", backgroundColor: "#ccc", color: "black", border: "none", cursor: "pointer" }}>
                            Refresh
                        </button>
                    </div>
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>Order Date</th>
                                <th>Customer Name</th>
                                <th>Customer Phone</th>
                                <th>Customer Address</th>
                                <th>Customer Pin</th>
                                <th>Product Name</th>
                                <th>Product Weight</th>
                                <th>Product Quantity</th>
                                <th>Product Price</th>
                                <th>Status</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentOrders.map(order => (
                                <tr key={order.OrderId}>
                                    <td>{order.OrderId}</td>
                                    <td>{new Date(order.OrderDate).toLocaleDateString()}</td>
                                    <td>{order.CustomerName}</td>
                                    <td>{order.CustomerPhone}</td>
                                    <td>{order.CustomerAddress}</td>
                                    <td>{order.CustomerPin}</td>
                                    <td>{order.ProductName}</td>
                                    <td>{order.ProductWeight}</td>
                                    <td>{order.ProductQuantity}</td>
                                    <td>{order.ProductPrice}</td>
                                    <td>{order.Status}</td>
                                    <td>{order.Amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="pagination">
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            &laquo;
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i + 1}
                                onClick={() => paginate(i + 1)}
                                className={i + 1 === currentPage ? 'active' : ''}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            &raquo;
                        </button>
                    </div>
                </>
            )}







            {view === 'users' && (
                <>
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Search by Phone"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ padding: "10px", flex: "1", marginRight: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                        />
                        <button onClick={handleSearchUsers} className="search-button"
                            style={{ padding: "10px 20px", marginRight: "10px", borderRadius: "5px", backgroundColor: "#009879", color: "white", border: "none", cursor: "pointer" }}>
                            Search
                        </button>
                        <button onClick={handleRefresh} className="refresh-button"
                            style={{ padding: "10px 20px", borderRadius: "5px", backgroundColor: "#ccc", color: "black", border: "none", cursor: "pointer" }}>
                            Refresh
                        </button>
                    </div>
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>State</th>
                                <th>City</th>
                                <th>Address</th>
                                <th>Pin</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUsers.map(user => (
                                <tr key={user.id} onClick={() => handleRowClick(user.Phone)} style={{ cursor: 'pointer' }}>
                                    <td>{user.id}</td>
                                    <td>{user.Name}</td>
                                    <td>{user.Phone}</td>
                                    <td>{user.State}</td>
                                    <td>{user.City}</td>
                                    <td>{user.Address}</td>
                                    <td>{user.Pin}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="pagination">
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            &laquo;
                        </button>
                        {Array.from({ length: totalUserPages }, (_, i) => (
                            <button
                                key={i + 1}
                                onClick={() => paginate(i + 1)}
                                className={i + 1 === currentPage ? 'active' : ''}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalUserPages}
                        >
                            &raquo;
                        </button>
                    </div>
                </>
            )}








            {view === 'pending' && (
                <>
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Search by Date"
                            value={dateSearchTerm}
                            onChange={(e) => setDateSearchTerm(e.target.value)}
                            style={{ padding: "10px", flex: "1", marginRight: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                        />
                        <button onClick={handleSearchDates} className="search-button"
                            style={{ padding: "10px 20px", marginRight: "10px", borderRadius: "5px", backgroundColor: "#009879", color: "white", border: "none", cursor: "pointer" }}>
                            Search
                        </button>
                        <button onClick={handleRefresh} className="refresh-button"
                            style={{ padding: "10px 20px", borderRadius: "5px", backgroundColor: "#ccc", color: "black", border: "none", cursor: "pointer" }}>
                            Refresh
                        </button>
                    </div>
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Order Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {distinctDates.map((date, index) => (
                                <tr
                                    key={index}
                                    onClick={() => pendingClick(format(new Date(date.OrderDate), 'yyyy-MM-dd'))}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td>{index + 1}</td>
                                    <td>{format(new Date(date.OrderDate), 'yyyy-MM-dd')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}







            {view === 'complete' && (
                <>
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Search by Date"
                            value={dateSearchTerm}
                            onChange={(e) => setDateSearchTerm(e.target.value)}
                            style={{ padding: "10px", flex: "1", marginRight: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                        />
                        <button onClick={handleSearchDates} className="search-button"
                            style={{ padding: "10px 20px", marginRight: "10px", borderRadius: "5px", backgroundColor: "#009879", color: "white", border: "none", cursor: "pointer" }}>
                            Search
                        </button>
                        <button onClick={handleRefresh} className="refresh-button"
                            style={{ padding: "10px 20px", borderRadius: "5px", backgroundColor: "#ccc", color: "black", border: "none", cursor: "pointer" }}>
                            Refresh
                        </button>
                    </div>
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Order Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {distinctDates.map((date, index) => (
                                <tr
                                    key={index}
                                    onClick={() => completeClick(format(new Date(date.OrderDate), 'yyyy-MM-dd'))}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td>{index + 1}</td>
                                    <td>{format(new Date(date.OrderDate), 'yyyy-MM-dd')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}













        </div>
    );
}
